module.exports = __webpack_public_path__ + "img/IMG_1024_L_Foamcore_MockedUp.796c7f84.jpg";